import dynamic from 'next/dynamic';
import AnnouncementBarTastic from './bar/announcment';
import CategorySliderTastic from './category-slider';
import HeroTastic from './content/hero';
import Tile from './content/tile';
import TilesGroupTastic from './content/tiles-group';
import ContentSliderTastic from './content-slider';
import Footer from './footer';
// import Header from './header';
import NotFoundTastic from './not-found';
import ProductSlider from './products/slider';
import SpacerTastic from './spacer';
import { TasticRegistry } from './types';
import AfdComponent from './address-afd';
import RecentlyViewedTastic from './recently-viewed-products';
import HeaderTastic from './header/index';
import YouMayAlsoLikeSliderTastic from './you-may-also-like';
import ShippingBannersTastic from './shipping-banners';
import HeaderTasticContentFul from './header/mega-menu';
import AlgoliaSearchPageTastic from './Algolia-Search-Page';
import DiscoverTastic from './content/discover';
import StoreLocatorTastic from './store-locator';
import FindStoreTastic from './find-store';
import TrustPilotReviewTastic from './trust-pilot-review';
import HomePageHeroBannerTastic from './homepage-hero-banner';
import AGClubTastic from './AG-Club';
import CustomerServiceTastic from './services';
import HighlightCategoryTastic from './content/highlight-category';
import PopularCategoryTastic from './content/popular-category';
import SecondaryBannerTastic from './homepage-secondary-banner';
import AlgoliaPopularProductTastic from './algolia-popular-product';
import ComparePage from './compareProduct';
import NewArrivalsTastic from './content/new-arrivals';
import CustomFittingPage from './Custom-Fitting-Page';
import GolfBidderPage from './golfbidder-page';
import InterestFreeCreditPage from './interest-free-credit-page';
import GolfInsurancePage from './golf-insurance-page';
import GolfHolidaysDirectPage from './golf-holidays-direct-page';
import BeginnerGolfPage from './beginner-golf-page';
import ReportPage from './report';
import AlgoliaLookingSimilarProductTastic from './algolia-looking-similar-items';
import AlgoliaRelatedProductTastic from './algolia-related-items';
import AlgoliaBoughtTogetherProductTastic from './algolia-bought-together-items';
import AlgoliaTrendingFacetProductTastic from './algolia-trending-facets';
import AlgoliaTrendingProductTastic from './algolia-trending-items';

const Markdown = dynamic(() => import('./markdown'));
const AccountDetails = dynamic(() => import('./account/details'));
const AccountLogin = dynamic(() => import('./account/login'));
const AccountOrdersHistory = dynamic(() => import('./account/orders'));
const AccountRegister = dynamic(() => import('./account/register'));
const ResetPassword = dynamic(() => import('./account/reset-password'));
const Checkout = dynamic(() => import('./checkout'));
const ThankYou = dynamic(() => import('./thank-you'));
const ProductDetails = dynamic(() => import('./products/details'));
// const ProductList = dynamic(() => import('./products/product-list'));
// const ProductListAlgolia = dynamic(() => import('./products/product-list-algolia'));
const ProductListColourTastic = dynamic(() => import('./products/product-list-colour'));
const SimilarProducts = dynamic(() => import('./products/similar-products'));
const OtherProducts = dynamic(() => import('./products/other-products'));
const Showcase = dynamic(() => import('./showcase'));
const Cart = dynamic(() => import('./cart'));
const Wishlist = dynamic(() => import('./wishlist'));
const PaymentRedirect = dynamic(() => import('./payment-redirect'));
const Notification = dynamic(() => import('./notification'));

export const tastics = {
  'commercetools/ui/checkout': Checkout,
  'commercetools/ui/thank-you': ThankYou,
  'commercetools/ui/agfooter': Footer,
  // 'commercetools/ui/header': Header,
  'commercetools/ui/content/tile': Tile,
  'commercetools/ui/content/hero': HeroTastic,
  'commercetools/ui/content/spacer': SpacerTastic,
  'commercetools/ui/content/showcase': Showcase,
  'commercetools/ui/content/markdown': Markdown,
  'commercetools/ui/cart': Cart,
  'commercetools/ui/products/details': ProductDetails,
  'commercetools/ui/products/product-list': ProductListColourTastic,
  'commercetools/ui/products/product-list-algolia': ProductListColourTastic,
  'commercetools/ui/products/slider': ProductSlider,
  'commercetools/ui/products/similar-products': SimilarProducts,
  'commercetools/ui/products/other-products': OtherProducts,
  'commercetools/ui/account/details': AccountDetails,
  'commercetools/ui/account/login': AccountLogin,
  'commercetools/ui/account/register': AccountRegister,
  'commercetools/ui/account/orders': AccountOrdersHistory,
  'commercetools/ui/account/reset-password': ResetPassword,
  'commercetools/ui/category-slider': CategorySliderTastic,
  'commercetools/ui/content/announcement-bar': AnnouncementBarTastic,
  'commercetools/ui/content/content-slider': ContentSliderTastic,
  'commercetools/ui/content/tiles-group': TilesGroupTastic,
  'commercetools/ui/not-found': NotFoundTastic,
  'commercetools/ui/wishlist': Wishlist,
  'commercetools/ui/afd': AfdComponent,
  'commercetools/ui/payment-redierct': PaymentRedirect,
  'commercetools/ui/content/notification': Notification,
  'commercetools/ui/products/recently-viewed-products': RecentlyViewedTastic,
  'frontastic/mega-menu': HeaderTasticContentFul,
  'commercetools/ui/header': HeaderTastic,
  'commercetools/ui/products/you-may-also-like': YouMayAlsoLikeSliderTastic,
  'commercetools/ui/content/shipping-banners': ShippingBannersTastic,
  'commercetools/ui/products/search': ProductListColourTastic,
  'commercetools/ui/content/discover': DiscoverTastic,
  'commercetools/ui/store-locator': StoreLocatorTastic,
  'commercetools/ui/find-store': FindStoreTastic,
  'commercetools/ui/trustpilot-review': TrustPilotReviewTastic,
  'commercetools/ui/content/homepage-hero-banner': HomePageHeroBannerTastic,
  'commercetools/ui/contentful/ag-club': AGClubTastic,
  'commercetools/ui/contentful/services': CustomerServiceTastic,
  'commercetools/ui/content/highlight-category-section': HighlightCategoryTastic,
  'commercetools/ui/content/popular-category': PopularCategoryTastic,
  'commercetools/ui/content/secondary-banner': SecondaryBannerTastic,
  'commercetools/ui/algolia/popular-product': AlgoliaPopularProductTastic,
  'commercetools/ui/products/product-compare': ComparePage,
  'commercetools/ui/content/new-arrivals': NewArrivalsTastic,
  'commercetools/ui/content/customfittingpage': CustomFittingPage,
  'commercetools/ui/content/golfbidder-page': GolfBidderPage,
  'commercetools/ui/content/interest-free-credit-page': InterestFreeCreditPage,
  'commercetools/ui/content/golf-insurance-page': GolfInsurancePage,
  'commercetools/ui/content/golf-holidays-direct-page': GolfHolidaysDirectPage,
  'commercetools/ui/content/beginner-golf-page': BeginnerGolfPage,
  'commercetools/ui/content/report-page': ReportPage,
  'commercetools/ui/algolia/trending-product': AlgoliaTrendingProductTastic,
  'commercetools/ui/algolia/trending-facet-product': AlgoliaTrendingFacetProductTastic,
  'commercetools/ui/algolia/looking-similar-product': AlgoliaLookingSimilarProductTastic,
  'commercetools/ui/algolia/related-product': AlgoliaRelatedProductTastic,
  'commercetools/ui/algolia/bought-together-product': AlgoliaBoughtTogetherProductTastic,
} as TasticRegistry;
